export const CREATE_VENDOR_REQUEST = 'CREATE_VENDOR_REQUEST';
export const CREATE_VENDOR_SUCCESS = 'CREATE_VENDOR_SUCCESS';
export const CREATE_VENDOR_FAILURE = 'CREATE_VENDOR_FAILURE';

export const GET_VENDOR_REQUEST = 'GET_VENDOR_REQUEST';
export const GET_VENDOR_SUCCESS = 'GET_VENDOR_SUCCESS';
export const GET_VENDOR_FAILURE = 'GET_VENDOR_FAILURE';